// Mention token format: @[Display Name](email) — same convention as
// deal-pipeline-crm, so the notification regex is shared across tools.
// (The CRM uses this format with emails as the identifier too.)

export const MENTION_TOKEN_REGEX = /@\[([^\]]+)\]\(([^)]+)\)/g;

export interface Mention {
  displayName: string;
  email: string;
}

export function extractMentions(text: string): Mention[] {
  if (!text) return [];
  const out: Mention[] = [];
  const re = new RegExp(MENTION_TOKEN_REGEX.source, "g");
  let m;
  while ((m = re.exec(text))) {
    out.push({ displayName: m[1]!, email: m[2]!.toLowerCase() });
  }
  return out;
}

/** Replace mention tokens with plain @Display Name. */
export function stripMentionTokens(text: string): string {
  if (!text) return "";
  return text.replace(MENTION_TOKEN_REGEX, (_, name) => `@${name}`);
}

export type TextSegment =
  | { type: "text"; value: string }
  | { type: "mention"; displayName: string; email: string };

/** Split text into alternating plain/mention segments for rendering. */
export function segmentText(text: string): TextSegment[] {
  if (!text) return [];
  const segments: TextSegment[] = [];
  let lastIndex = 0;
  const re = new RegExp(MENTION_TOKEN_REGEX.source, "g");
  let m;
  while ((m = re.exec(text))) {
    if (m.index > lastIndex) {
      segments.push({ type: "text", value: text.slice(lastIndex, m.index) });
    }
    segments.push({ type: "mention", displayName: m[1]!, email: m[2]!.toLowerCase() });
    lastIndex = m.index + m[0].length;
  }
  if (lastIndex < text.length) {
    segments.push({ type: "text", value: text.slice(lastIndex) });
  }
  return segments;
}
